import MetaSchema from './MetaSchema';

export default MetaSchema;
